import type {HotelCategoryType} from '@travel-frontend/ui-components';
import type {InferOutput} from 'valibot';

import {boolean, number, object, string} from 'valibot';

export const RecoInfoSchema = object({
  pricesSkipped: boolean(),
  placementId: string(),
  modelId: string(),
  pricesTime: number(),
  strategy: string(),
  ptoken: string(),
});

export type RecoInfo = InferOutput<typeof RecoInfoSchema>;

export type Recommendation = {
  hotelId: string;
  link: string;
  hotelName: string;
  formattedPrice: string;
  price: number;
  image: string;
  category: {
    type: HotelCategoryType;
    value: number;
  };
  pax: number;
  travelDuration: number;
  boardType?: string;
  city?: string;
  region?: string;
  index: number;
  recoInfo: null | RecoInfo;
};
